import {Store,Module,ActionContext} from 'vuex'
import {ListModule, ListState, ListStateItem, ListModuleItem} from '@/store/shared'
import Sender from './entity'
import {$http} from '@/lib'
import {PageResult} from '@/store/shared/entity';

interface SenderState extends ListStateItem<Sender>{
    editSender:Sender;

    senderList: Array<any>;
}
class SenderModule extends ListModuleItem<SenderState,any,Sender>{

    constructor() {
        super();
        Object.assign(this.state, this.overrideState);
        Object.assign(this.mutations, this.overrideMutations);
    }

    overrideState={
        editSender:new Sender(),
        senderList: new Array<any>(),
    }

    actions={
        async getAll(context:ActionContext<SenderState,any>,payload:any){
            context.state.table.loading=true;
            let reponse=await $http.get('/services/app/Sender/GetAll',{params:payload.data});
            context.state.table.loading=false;
            let page=reponse.data.result as PageResult<Sender>;
            context.state.table.totalCount=page.totalCount;
            context.state.table.list=page.items;
        },
        async create(context:ActionContext<SenderState,any>,payload:any){
            await $http.post('services/app/Sender/Create',payload.data);
        },
        async update(context:ActionContext<SenderState,any>,payload:any){
            await $http.put('services/app/Sender/Update',payload.data);
        },
        async delete(context:ActionContext<SenderState,any>,payload:any){
            await $http.delete('services/app/Sender/Delete?Id='+payload.data.id);
        },
        async get(context:ActionContext<SenderState,any>,payload:any){
            
            let reponse=await $http.get('services/app/Sender/Get?Id='+payload.id);
            context.state.editSender = reponse.data.result;
            
            return reponse.data.result;
        },
        async getSenderList(context:ActionContext<SenderState,any>){

            let reponse = await $http.get('services/app/Sender/GetSenderOption');
            context.state.senderList = reponse.data.result;
        },
    };
    overrideMutations={
        edit(state:SenderState,sender:Sender){
            state.editSender=sender;
        }
    }
}
const senderModule=new SenderModule();
export default senderModule;